import { render, staticRenderFns } from "./confirm-academic-references.vue?vue&type=template&id=66ca8682&scoped=true&"
import script from "./confirm-academic-references.vue?vue&type=script&lang=js&"
export * from "./confirm-academic-references.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca8682",
  null
  
)

export default component.exports